var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.375,
    height: 38,
    viewBox: "0 0 42.375 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "browser_icon",
    "data-name": "browser icon",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_901",
    "data-name": "Line 901",
    x2: 39.43,
    transform: "translate(0 9.925)",
    fill: "none",
    stroke: "#466dec",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M13.046,13.039a1.33,1.33,0,1,1-1.33-1.33,1.33,1.33,0,0,1,1.33,1.33",
    transform: "translate(-7.111 -7.848)",
    fill: "#466dec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M21.56,13.039a1.33,1.33,0,1,1-1.33-1.33,1.33,1.33,0,0,1,1.33,1.33",
    transform: "translate(-11.856 -7.848)",
    fill: "#466dec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M30.074,13.039a1.33,1.33,0,1,1-1.33-1.33,1.33,1.33,0,0,1,1.33,1.33",
    transform: "translate(-16.598 -7.848)",
    fill: "#466dec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1346",
    "data-name": "Rectangle 1346",
    width: 39.375,
    height: 35,
    rx: 3,
    fill: "none",
    stroke: "#466dec",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserIcon);
export default __webpack_public_path__ + "static/media/BrowserIcon.e5d24fa659c2def0cba4754b8c52f868.svg";
export { ForwardRef as ReactComponent };